
    import { getRemoteAppConfig, getRemoteAppTheme, getAppConfigId, getAppConfig } from '/src/data/app-config/configs/configUtilities';

    window.appConfigPromise = (async () => {
      try {
          // Get app config ID using the full resolution logic
          const appConfigId = getAppConfigId();
          let appConfig = getAppConfig(); // This will return the default config

          if (appConfigId) {
            // Try to load config based on app config ID
            try {
              appConfig = await getRemoteAppConfig(appConfigId);
              try {
                await getRemoteAppTheme();
              } catch (error) {
                console.error('Failed to load app theme:', error);
              }
            } catch (error) {
              console.warn(`Failed to load app config for ${appConfigId}, using default:`, error);
              appConfig = getAppConfig(); // Fall back to default config
            }
          }

          // Set favicons and title
          const favicons = document.querySelectorAll('link[rel*="icon"]');
          const { defaultDocumentTitle, favicon16Href, favicon32Href, favicon96Href } = appConfig;

          favicons.forEach((icon) => {
            if (icon.id === 'fav16') icon.href = favicon16Href;
            if (icon.id === 'fav32') icon.href = favicon32Href;
            if (icon.id === 'fav96') icon.href = favicon96Href;
          });
          document.title = defaultDocumentTitle;

          return appConfig;
      } catch (error) {
        console.error('Failed to initialize app:', error);
        throw error;
      }
    })();
  